<div class="four_zero_four_page">
    <div class="page_wrap_sections">
        <div class="left_side_secitons">
            <div class="circle_sections">
                <h2>404</h2>
                <p>無法找到頁面</p>
            </div>
        </div>
        <div class="right_side_secitons">
            <h2>不好了！</h2>
            <h3>我們上天下海還是找不到您要前往的頁面。</h3>
            <p>您使用的連結可能已過期、發生錯誤、或您沒有訪問權限。</p>
            <button [routerLink]="['']">回到首頁</button> 
        </div>
    </div>
</div>
